<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import EmpresasTable from './empresas-table.vue'
import appConfig from "@/app.config";
import {condicoesChart1, condicoesChart2 } from "../components/data-simulados";
import Swal from "sweetalert2";
import 'vue3-lottie/dist/style.css'
import exportFromJSON from "export-from-json"
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Empresas",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, EmpresasTable, Loader  },
  data() {
    return {

      title: 'Empresas',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Empresas',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      empresasTable: null,
      empreChart1: condicoesChart1,
      empreChart2: condicoesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      showModalReproTrack: false,
      apiReproTrack: null,
      dtini: moment(new Date()).subtract(90,'days').format('YYYY-MM-DD'),
      dtfim: moment(new Date()).format('YYYY-MM-DD'),

    }
  },


  methods: {

    reproSaldosCustos() {
      console.log('reproSaldosCustos')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reprocessar Saldos e Custos",
        text: "Esta operação vai eliminar todos os saldos de produtos e reprocessar, deseja confirmar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingList = true
          api.get(`${getBaseUrl()}api/reprosalcust`).then((res) => {
            console.log('then axios')
            console.log(res.data)
            this.loadingList = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data,
              showConfirmButton: false,
              timer: 2500
            })
          })
        }
      })

    },


    // reproTrack() {
    //   console.log('reproTrack')
    //   this.apiReproTrack = null
    //   this.showModalReproTrack = true
    // },
    //
    // confirmarReproTrack(){
    //   console.log('confirmarReproTrack')
    //   this.showModalReproTrack = false
    //
    //   Swal.fire({
    //     position: "center",
    //     icon: "question",
    //     title: "Reprocessar API",
    //     text: "Esta operação vai eliminar todo o rastreio atual para que possa realizar uma nova consulta e pode levar algumas horas para finalizar, deseja confirmar?",
    //     confirmButtonText: "Confirmar",
    //     cancelButtonText: "Cancelar",
    //     showCancelButton: true,
    //     showConfirmButton: true,
    //   }).then(result => {
    //     if (result.value) {
    //       this.loadingList = true
    //       api.get(`${getBaseUrl()}api/reprocapi`, {
    //         params: {
    //           'apiData': this.apiReproTrack,
    //           'dtini': this.dtini,
    //           'dtfim': this.dtfim
    //         }
    //       }).then((res) => {
    //         console.log('then axios')
    //         console.log(res.data)
    //         this.loadingList = false
    //
    //         Swal.fire({
    //           position: "top-end",
    //           icon: "success",
    //           title: res.data,
    //           showConfirmButton: false,
    //           timer: 2500
    //         })
    //       })
    //     }
    //   })
    // },


    exportExcel(){
      console.log('exportExcel')
      const data = this.empresasTable
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      console.log('atualizaDataList')

      this.loadingList = true
      api.get(`${getBaseUrl()}api/empresas`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.empresasTable = res.data[0]
          this.title = `(${this.empresasTable.length}) Empresas`
          this.loadingList = false
          this.loadingGraph = false
        }
      });
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)

      this.loadingList = true
      api.delete(`${getBaseUrl()}api/empresa`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    alterouReg(regSelecionado) {
      console.log('alterouReg_pai')
      console.log(regSelecionado)
      this.loadingList = true

      this.errosValid = []
      api.post(`${getBaseUrl()}api/empresa`, {
        empresaData: regSelecionado
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        this.loadingList = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.atualizaDataList()

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.loadingList = false
      })
    },
  },
  mounted() {
    console.log('mounted empresas-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-secondary" @click="exportExcel" title="Export">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
<!--                    Comentado por Guilherme e aprovado pelo Rogério-->
<!--                    Justificativa: Principalmente o cliente Grupo festa quase todo dia reprocessa status e fica -->
<!--                    reclamando que os status não estão sendo processados  -->

<!--                    <b-button variant="outline-secondary" class="mx-2" @click="reproTrack" title="Reprocessa Status">-->
<!--                      <i class="bx bxs-info-circle font-size-16 align-middle "></i>-->
<!--                    </b-button>-->

                    <b-button variant="outline-secondary" @click="reproSaldosCustos" title="Reprocessa Saldo/Custo">
                      <i class="bx bxs-dollar-circle font-size-16 align-middle "></i>
                    </b-button>

                  </div>
                </div>
              </div>






              <div class="col-sm-7">
                <div class="text-sm-end">

                  <router-link :to="`/empresa/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Nova Empresa
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <EmpresasTable v-if="!loadingList"
                            ref="childTable"
                            :empresasList="empresasTable"
                            @deletareg="deletouReg"
                            @alterareg="alterouReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!loadingGraph">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Condições Destaque Mês</h4>
            <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="empreChart1.series"
                :options="empreChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Destaques Semana</h4>
            <apexchart
                class="apex-charts"
                height="320"
                type="donut"
                dir="ltr"
                :series="empreChart2.series"
                :options="empreChart2.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>



<!--    <b-modal title="Reprocessar Tracking" v-model="showModalReproTrack" centered hide-footer>-->
<!--      <div class="col-md-12">-->
<!--        <div class="mb-3">-->
<!--          <label for="tipooperacao">Selecionar API ou deixar em branco para reprocessar todas</label>-->

<!--        </div>-->
<!--      </div>-->
<!--      <div class="row">-->



<!--        <div class="col-md-12">-->
<!--          <div class="mb-3">-->
<!--            <label for="tipo">Api Reprocessar</label>-->
<!--            <select-->
<!--                id="tipo"-->
<!--                v-model="apiReproTrack"-->
<!--                class="form-control">-->
<!--              <option value="null">Reprocessar Todas</option>-->
<!--              <option value="ACX">Acerta Express</option>-->
<!--              <option value="AMAZON">Amazon</option>-->
<!--              <option value="ANYMARKET">Any Market</option>-->
<!--              <option value="B2WNOVA">B2W Nova Api</option>-->
<!--              <option value="BLING">Bling</option>-->
<!--              <option value="BRP">Braspres</option>-->
<!--              <option value="CORREIOS">Correios</option>-->
<!--              <option value="ESLC">ESL Cloud</option>-->
<!--              <option value="FOCUSNFE">Focus NFe</option>-->
<!--              <option value="JET">j&T Express</option>-->
<!--              <option value="JDL">JadLog</option>-->
<!--              <option value="LEROYMER">Leroy Merlin</option>-->
<!--              <option value="LJTO">LogJato</option>-->
<!--              <option value="LOJAMEC">Loja do Mecânico</option>-->
<!--              <option value="MAGALU">Magazine Luiza</option>-->
<!--              <option value="MIRA">Mira</option>-->
<!--              <option value="MOVVI">Movvi</option>-->
<!--              <option value="OCO">OCOREN</option>-->
<!--              <option value="OURNGR">Ouro Negro transportes</option>-->
<!--              <option value="QLTY">Quality</option>-->
<!--              <option value="PATR">Patrus</option>-->
<!--              <option value="RDV">Rodonavis</option>-->
<!--              <option value="RELM">Realmed</option>-->
<!--              <option value="SKYHUB">SkyHub</option>-->
<!--              <option value="SOL">Solistica</option>-->
<!--              <option value="SSW">SSW</option>-->
<!--              <option value="TRAYCORP">TrayCorp</option>-->
<!--              <option value="TNT">TNT</option>-->
<!--              <option value="TRCO">Transcourier</option>-->
<!--              <option value="TRV">Translovato</option>-->
<!--              <option value="VTEX">Vtex</option>-->
<!--            </select>-->

<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--      <div class="row mt-3">-->
<!--        <div class="mb-1 col-md-5">-->
<!--          <label for="dtini">Dt. Inicial</label>-->
<!--          <input-->
<!--              id="dtini"-->
<!--              v-model="dtini"-->
<!--              type="date"-->
<!--              class="form-control"-->
<!--              placeholder="Dt. Inicial"/>-->
<!--        </div>-->

<!--        <div class="mb-1 col-md-5">-->
<!--          <label for="dtfim">Dt. Final</label>-->
<!--          <input-->
<!--              id="dtfim"-->
<!--              v-model="dtfim"-->
<!--              type="date"-->
<!--              class="form-control"-->
<!--              placeholder="Dt. Final"/>-->
<!--        </div>-->

<!--        <span class="text-muted">Período de Reprocessamento (padrão inicial 90 dias). </span>-->
<!--      </div>-->

<!--      <div class="text-end mt-5">-->
<!--        <b-button variant="light" @click="showModalReproTrack = false">-->
<!--          <i class="bx bx-block font-size-16 align-middle me-2"></i>-->
<!--          Cancelar-->
<!--        </b-button>-->
<!--        <b-button type="submit" variant="success" class="ms-1" @click="confirmarReproTrack">-->
<!--          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
<!--          Confirmar-->
<!--        </b-button>-->
<!--      </div>-->
<!--    </b-modal>-->


  </Layout>
</template>
